import { isProd as envIsProd } from "../configs/environment";

const searchParams = window.location.search;

const getParams = () => {
  const searchParams = window.location.search;
  const urlParams = new URLSearchParams(searchParams);
  const allParams = {};
  urlParams.forEach((value, key) => {
    allParams[key] = value;
  });
  return allParams;
};

const handleParams = (key, value) => {
  const searchParams = window.location.search;
  const urlParams = new URLSearchParams(searchParams);
  if (key) {
    urlParams.delete(key);
    urlParams.append(key, value);
  }
  return "?" + urlParams.toString();
};

// isProd is now determined by environment variable at build time
const isProd = envIsProd;

export { getParams, searchParams, handleParams, isProd };
